import { render, staticRenderFns } from "./GraphDetail96.vue?vue&type=template&id=60aed001&scoped=true"
import script from "./GraphDetail96.vue?vue&type=script&lang=js"
export * from "./GraphDetail96.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aed001",
  null
  
)

export default component.exports